<template>
    <div id="Layout">
        <mu-container fluid class="main_content" style="margin-left:64px;">
            <leftNav/>
            <topNav/>
            <router-view></router-view>
        </mu-container>
    </div>
</template>
<script>
import leftNav from "@/components/leftNav"
import topNav from "@/components/TopNav" 
export default {
    name: 'Layout',
    data() {
        return {
            isRouterAlive: true,
        }
    },
    components: { leftNav, topNav },
    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Layout.vue